var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90826 20C5.39101 20 4.94365 19.8264 4.56619 19.4793C4.18873 19.1321 4.00001 18.7314 4.00001 18.2769L4.00001 6.89704C4.00001 6.41736 4.18874 6.0071 4.56619 5.66627C4.94365 5.32544 5.39101 5.15503 5.90826 5.15503L7.14549 5.15503L7.14549 4L8.8021 4L8.8021 5.15503L15.1769 5.15503L15.1769 4L16.8336 4L16.8336 5.15503L18.0708 5.15503C18.602 5.15503 19.0564 5.32545 19.4338 5.66627C19.8113 6.0071 20 6.41736 20 6.89704L20 18.2769C20 18.7314 19.8113 19.1322 19.4338 19.4793C19.0564 19.8264 18.602 20 18.0708 20L5.90826 20ZM5.90826 18.2769L18.0708 18.2769L18.0708 10.3432L5.90826 10.3432L5.90826 18.2769Z",
    fill: "#121E28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2421f5692e3f34c786084dfc9380e834.svg";
export { ForwardRef as ReactComponent };